/**
  On mobile devices: uses native date picker
  On desktop browsers: uses specific version of Pikaday that is accessible


  This should be changed so that the button to trigger the calendar comes afterwards.
  This does not match other accessible inputs like:
  http://www.oaa-accessibility.org/examplep/datepicker1/
  AND
  https://www.ssa.gov/accessibility/bpl/bps/forms/calendar/default.htm
**/

import Pikaday from 'pikaday';
import moment from 'moment';

var datepickerDirective = function (config) {
  return {
    scope: {
      'ngModel': '=',
      'minDate': '=',
      'maxDate': '=',
      'dateRequired': '='
    },
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, elem, attrs, ctrl) {
      var dateFormat = 'YYYY-MM-DD';
      var el = document.createElement('input');
      var notADateValue = 'not-a-date';
      el.setAttribute('type', 'date');
      el.setAttribute('value', notADateValue);
      var supportsDate = !(el.value === notADateValue);
      var isTouchDevice = ('ontouchstart' in window || navigator.msMaxTouchPoints);
      var usingDateInput = (supportsDate && isTouchDevice);
      if (usingDateInput) {
        elem.attr('type', 'date');
        scope.$watch('model', function (value) {
          if (value) {
            elem.val(value);
          }
        });
        scope.$watch('minDate', function (value) {
          if (value) {
            elem.attr('min', value);
          }
        });
        scope.$watch('maxDate', function (value) {
          if (value) {
            elem.attr('max', value);
          }
        });
      } else {
        var userFriendlyFormat = 'MM/DD/YYYY';
        elem.attr('type', 'text');
        elem.attr('autocomplete', 'off');
        elem.attr('placeholder', 'mm/dd/yyyy');
        var options = {
          field: elem[0]
        };
        options.format = userFriendlyFormat;
        options.onSelect = function (date) {
          var formattedDate = moment(date).format(dateFormat);
          ctrl.$setViewValue(formattedDate);
        };
        var picker = new Pikaday(options);
        scope.$on('$destroy', function () {
          picker.destroy();
        });
        scope.$watch('model', function (value) {
          if (value) {
            picker.setDate(moment(value).format(dateFormat));
          }
        });
        // not using these for now as disabling entry altogether can be very confusing
        // scope.$watch('minDate', function (value) {
        //   if (value) {
        //     picker.setMinDate(moment(value).startOf('day').toDate());
        //   }
        // });
        // scope.$watch('maxDate', function (value) {
        //   if (value) {
        //     picker.setMaxDate(moment(value).startOf('day').toDate());
        //   }
        // });
      }

      ctrl.$render = function () {
        if (scope.ngModel) {
          if (usingDateInput) {
            elem.val(scope.ngModel);
          } else {
            var formattedDate = moment(scope.ngModel).format(userFriendlyFormat);
            elem.val(formattedDate);
            picker.setDate(formattedDate);
          }
        }
      };

      ctrl.$validators.required = function (modelValue) {
        if (!scope.dateRequired) {
          return true;
        }        
        return moment(modelValue, dateFormat).isValid();
      };

      ctrl.$validators.min = function (modelValue) {
        if (!scope.minDate) {
          return true;
        }
        var dateObj = moment(modelValue, dateFormat).startOf('day').toDate();
        if (modelValue || scope.dateRequired) {
          var minDate = moment(scope.minDate, dateFormat).startOf('day').toDate();
          return minDate <= dateObj;
        }
        return true;
      };

      ctrl.$validators.max = function (modelValue) {
        if (!scope.maxDate) {
          return true;
        }
        var dateObj = moment(modelValue, dateFormat).startOf('day').toDate();
        var maxDate = moment(scope.maxDate, dateFormat).startOf('day').toDate();
        if (modelValue || scope.dateRequired) {
          return maxDate >= dateObj;
        }
        return true;
      };

      scope.$watch('minDate', function() {
        ctrl.$validate();
      });

      scope.$watch('maxDate', function() {
        ctrl.$validate();
      });

    }
  };
};
export default datepickerDirective;


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/datePickerDirective.js
// module id = 32
// module chunks = 0